import { routeUrl } from "@/app/routes";
import {
  READ_CARD_ROW_LIMIT,
  ReadCardFrame,
} from "@/features/copilot/components/read-cards/read-card-frame";
import type { PulseActionItem } from "@/features/copilot/schemas/copilot-read-cards.schema";
import { formatDateOnly } from "@/shared/lib/format-date-only";

/// Total over today's statuses; anything new reads as "Action" rather than leaking a raw enum.
const ACTION_STATUS_LABEL: Record<string, string> = {
  suggested: "Suggested",
  accepted: "Accepted",
  in_progress: "In progress",
  completed: "Completed",
  measured: "Measured",
  closed: "Closed",
  dismissed: "Dismissed",
};

function actionMeta(action: PulseActionItem): string {
  const due = formatDateOnly(action.expectedCompletionDate ?? null);
  return [
    ACTION_STATUS_LABEL[action.status] ?? "Action",
    action.isBlocked ? "Blocked" : null,
    action.owner?.name ?? null,
    due ? `Due ${due}` : null,
  ]
    .filter((part): part is string => part !== null)
    .join(" · ");
}

export function PulseActionsReadCard({
  items,
  slug,
  hasMore = false,
}: {
  items: PulseActionItem[];
  slug: string;
  hasMore?: boolean;
}) {
  const shown = items.slice(0, READ_CARD_ROW_LIMIT);
  return (
    <ReadCardFrame
      title="Pulse actions"
      viewAllHref={routeUrl.actions.mine(slug)}
      hiddenCount={items.length - shown.length}
      hasMore={hasMore}
    >
      {shown.map((action) => (
        <li key={action.id}>
          <a
            href={routeUrl.actions.detail(slug, action.id)}
            className="block space-y-0.5 px-3 py-2 hover:bg-muted/60 focus-visible:outline-2 focus-visible:outline-ring"
          >
            <span className="line-clamp-2 break-words">{action.untrustedTitle}</span>
            <span className="block truncate text-xs text-text-secondary">{actionMeta(action)}</span>
          </a>
        </li>
      ))}
    </ReadCardFrame>
  );
}
